import * as React from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemText from "@mui/material/ListItemText";
import { Link, useNavigate } from "react-router-dom";
import { UserContext } from "../auth/auth-context";
import { Staff } from "../../types";
import { useSelectedBusiness } from "../../redux/store";
import Box from "@mui/material/Box";
import AccountCircle from "@mui/icons-material/AccountCircle";
// Import the notification ring component
import NotificationBadge from "../reminder/notificationBadge";
import { Tooltip } from "@mui/material";

export default function AccountMenu(props: any) {
  const userContext = React.useContext(UserContext);
  const selectedBusiness = useSelectedBusiness();
  const navigate = useNavigate();

  // Account menu state (triggered by profile image)
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const accountMenuOpen = Boolean(anchorEl);

  // Account menu handlers
  const handleAccountMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleAccountMenuClose = () => {
    setAnchorEl(null);
  };

  // Logout handler
  const handleLogout = () => {
    userContext.logout();
    navigate("/");
    window.location.reload();
  };

  // Get current staff image from selected business
  const currentStaffImage = selectedBusiness?.businessStaffs?.find(
    (staff: Staff) => Number(staff.id) === userContext?.providerUser?.staffId
  )?.image;

  // Use staff email for notifications

  const email = userContext?.providerUser?.email;
  const CREATE_BUSINESS_PROFILE = "Create a business profile first";

  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      {/* Notification ring (clicking shows notifications popover) */}
      {userContext?.providerUser?.staffId && (
        <NotificationBadge
          currentStaffImage={currentStaffImage}
          email={email}
        />
      )}

      {/* Profile image triggers the account menu */}
      <Box onClick={handleAccountMenuClick} sx={{ cursor: "pointer", ml: 2 }}>
        {currentStaffImage ? (
          <img
            src={currentStaffImage.url}
            alt="Profile"
            style={{
              width: 30,
              height: 30,
              borderRadius: "50%",
              objectFit: "cover",
            }}
          />
        ) : (
          <AccountCircle sx={{ fontSize: 30 }} />
        )}
      </Box>

      {/* Account Menu */}
      <Menu
        id="account-menu"
        anchorEl={anchorEl}
        open={accountMenuOpen}
        onClose={handleAccountMenuClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        sx={{
          "& .MuiPaper-root": {
            display: "flex",
            flexDirection: "column",
            minWidth: "150px",
            maxWidth: "200px",
            maxHeight: "300px",
            overflowY: "auto",
            borderRadius: "8px",
            boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
          },
        }}
      >
        <MenuItem
          onClick={handleAccountMenuClose}
          component={Link}
          to="/profile"
          sx={{ padding: "6px 12px", fontSize: "14px" }}
        >
          <ListItemText primary="👤 Profile" sx={{ textAlign: "left" }} />
        </MenuItem>

        <MenuItem
          onClick={handleAccountMenuClose}
          component={Link}
          to="/myschedule"
          sx={{ padding: "6px 12px", fontSize: "14px" }}
        >
          <ListItemText primary="📅 My Schedule" sx={{ textAlign: "left" }} />
        </MenuItem>

        <Tooltip
          title={selectedBusiness ? "" : CREATE_BUSINESS_PROFILE}
          placement="right"
        >
          {/* span needed so Tooltip works on a disabled child */}
          <span>
            <MenuItem
              component={selectedBusiness ? Link : "div"}
              to={
                selectedBusiness
                  ? `/${selectedBusiness.businessBasic.url}/${userContext?.providerUser.url}/wallet`
                  : undefined
              }
              disabled={!selectedBusiness}
              sx={{
                padding: "6px 12px",
                fontSize: "14px",
                cursor: selectedBusiness ? "pointer" : "not-allowed",
              }}
            >
              <ListItemText
                primary="🪙 PlanyCoin Wallet"
                sx={{ textAlign: "left" }}
              />
            </MenuItem>
          </span>
        </Tooltip>

        <MenuItem
          onClick={handleLogout}
          sx={{ padding: "6px 12px", fontSize: "14px" }}
        >
          <ListItemText primary="🚪 Logout" sx={{ textAlign: "left" }} />
        </MenuItem>
      </Menu>
    </Box>
  );
}
